import React from 'react';
import { useNavigate } from 'react-router';

const PlanCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh]">
      <div className="bg-surface p-8 rounded-lg shadow-md text-center">
        <p>Your subscription process was canceled. If you have any questions, please contact support.</p>
        <button
          className="mt-4 bg-accent text-content-inverse px-4 py-2 rounded hover:bg-btn-primary-hover"
          onClick={() => navigate('/settings/plan')}
        >
          Return to Plans
        </button>
      </div>
    </div>
  );
};

export default PlanCancel;
